var $d7d8afc6ca45b1fe$exports = {};
$d7d8afc6ca45b1fe$exports = {
    "(optional)": `(valgfrit)`,
    "(required)": `(obligatorisk)`
};


export {$d7d8afc6ca45b1fe$exports as default};
//# sourceMappingURL=da-DK.mjs.map
